import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

var throttle = function throttle(func, delay) {
  var inProgress = false;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (inProgress) {
      return;
    }
    inProgress = true;
    setTimeout(function () {
      func.apply(undefined, args);
      inProgress = false;
    }, delay);
  };
};

var useWindowWidth = function useWindowWidth() {
  var _useState = useState(window.innerWidth),
      _useState2 = _slicedToArray(_useState, 2),
      windowWidth = _useState2[0],
      setWindowWidth = _useState2[1];

  useEffect(function () {
    var handleResize = throttle(function () {
      setWindowWidth(window.innerWidth);
    }, 500);

    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowWidth;
};

export default useWindowWidth;